import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    OnDestroy,
    ViewChild,
    HostListener,
    Inject,
} from '@angular/core';
import { LoadService } from 'src/app/services/application/load.service';
import moment from 'moment';
import {
    expandedAnimation,
    rightPanelAnimation,
} from '../../animations/height.animation';
import { IPeriod } from '../../interfaces/period.interface';
import {
    IDoctor,
    IRnumbDate,
    IServ,
    ISpec,
    IStaticFilter,
    Doctor,
    IFilial,
    ISpecByDep,
    IDep,
    Department,
    IRecTalon,
} from '../../interfaces/record.interface';
import { IService } from '../../interfaces/services';
import { ConfigService } from '../../services/application/config.service.';
import { RecordService } from '../../services/record.service';
import { strToDate } from '../application/global.function';
import { DoctorService } from 'src/app/services/doctor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';
import { lastValueFrom } from 'rxjs';
import { ServModalComponent } from 'src/app/modals/service-modal/service-modal.component';
import { Utils } from 'src/app/services/utils';
import { APP_BASE_HREF } from '@angular/common';

@Component({
    selector: 'app-rec-pc',
    templateUrl: './rec.component.html',
    styleUrls: ['./rec.component.scss'],
    animations: [expandedAnimation, rightPanelAnimation],
})
export class RecComponent implements OnInit, AfterViewInit, OnDestroy {
    statusTab: number = 1; // Тип закладки (0-По филиалу, 1- По специальности)
    //filialMode: boolean;
    loadingListSpec = false; // Загрузка специальностей
    loadingListFil = false; // Загрузка филиалов
    loadingListDepSpec = false; // загрузка специальностей по филиалу
    loadingListDoc = false; // Загрузка докторов
    isMobile: boolean = false;
    private mediaQuery: MediaQueryList | undefined;
    private mediaQueryListener:
        | ((this: MediaQueryList, ev: MediaQueryListEvent) => any)
        | null = null;

    @ViewChild('InputBlocSpec') InputBlocSpecEL: ElementRef | undefined;
    @ViewChild('InputBlocServ') InputBlocServEL: ElementRef | undefined;
    originalSrvLists: { [doctorId: number]: IServ[] } = {};
    searchInputValue: { [doctorId: string]: string } = {};
    showMobilePicker: boolean = false;

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;

        // Close all open dropdowns if click is outside any service-select
        Object.keys(this.openSelectStates).forEach((key) => {
            const doctorId = Number(key);
            if (this.openSelectStates[doctorId]) {
                const dropdownContainer = document.querySelector(
                    `[data-doctor-id="${doctorId}"]`,
                );
                if (
                    dropdownContainer &&
                    !dropdownContainer.contains(clickedElement)
                ) {
                    this.openSelectStates[doctorId] = false;
                }
            }
        });

        // Existing logic for other dropdowns (e.g., search lists)
        if (
            !clickedElement.closest('.search-list') &&
            this.selectedFilial &&
            !clickedElement.closest('.filter__wrapper')
        ) {
            // this.isSearchListVisible = false;
            this.searchAmine = 'off';
        }

        if (
            !clickedElement.closest('.filter__dropdown-list') &&
            !clickedElement.closest('.filter__dropdown-toggle')
        ) {
            this.isDropdownOpen = false;
        }
    }

    // @HostListener('document:click', ['$event'])
    // handleClickOutside(event: MouseEvent) {
    //     if (event.type !== 'click' || event.isTrusted === false) {
    //         return;
    //     }
    //     if (event.detail === 0) {
    //         return;
    //     }
    //     const clickedElement = event.target as HTMLElement;

    //     if (!clickedElement.closest('.service-select')) {
    //         Object.keys(this.openSelectStates).forEach((key) => {
    //             this.openSelectStates[Number(key)] = false;
    //         });
    //     }

    //     if (
    //         !clickedElement.closest('.search-list') &&
    //         this.selectedFilial &&
    //         !clickedElement.closest('.filter__wrapper')
    //     ) {
    //         this.isSearchListVisible = false;
    //         this.searchAmine = 'off';
    //     }
    //     if (
    //         !clickedElement.closest('.filter__dropdown-list') &&
    //         !clickedElement.closest('.filter__dropdown-toggle')
    //     ) {
    //         this.isDropdownOpen = false;
    //     }
    // }
    _specList: ISpec[] = []; // полный список
    specList: ISpec[] = []; // Отфильтрованный
    _filialList: IFilial[] = []; // полный список филиалов
    filialList: IFilial[] = []; // Отфильтрованный
    specByFilialList: ISpecByDep[] = []; // Список специальностей по филиалу
    _specByFilialList: ISpecByDep[] = []; // Список специальностей по филиалу filtred
    searchStr: string = ''; // Строка поиска
    // searchStrSrv: string = ''; // Строка поиска услуги у доктора
    searchStrSrv: { [doctorId: number]: IServ[] } = {};
    searchAmine = 'off';
    panelRnumbAmine = 'off';

    staticFilterBTNs: IStaticFilter[] = []; // Список кнопок фильтра сверху страницы
    staticFilterSelected: any; // выбраные фильтр
    selectedDoctor: IDoctor | undefined; //Doctor
    selectDoc: IDoctor | null = null;
    //  selectedSpec: number | null = null;
    periodStart: Date = new Date();
    periodEnd: Date = new Date();
    talonPickerAnime = 'off';
    //  _searchList: ISearchServ[] = [];
    //  searchList: ISearchServ[] = [];
    selectedSpec: ISpec | null = null;
    selectedFilial: IFilial | null = null;

    dtBegin: Date | null = null; // Дата начала
    dtEnd: Date | null = null; // Дата ококнчания
    orderUP = true; // С начала последние
    orderUPText: string = 'Сначала последние';

    recList: IService[] | null = null;
    //  recDoctors: IDocRec[] | null = null;
    recDoctors: IDoctor[] | null = null;
    // selectedSrv: IServ | null = null; // Выбранная услуга
    selectedSrv: IServ | undefined | null;
    recListLength: number = 0; // Количество записей

    loadingRecList = false; // Загрузка
    loadingSpecList = false; // Загрузка специальностей

    paramsTalonpicker!: IRnumbDate;
    showTalonPicker = false;
    //мобильный фильтр
    isDropdownOpen = false;
    isMobileFlilterOpen = false;
    activeItem: any;
    openMobileTemplate = false;
    isSearchListVisible: boolean = true;
    isFilialListVisible: boolean = true;
    public isFilialMode: boolean = false;
    _wasVisible = false;
    //   showCalendar = false;
    private _showCalendar = false;
    get showCalendar() {
        return this._showCalendar;
    }
    set showCalendar(value: boolean) {
        if (value) {
            this._wasVisible = true;
        }
        this._showCalendar = value;
    }

    constructor(
        private configS: ConfigService,
        private ds: DoctorService,
        private rs: RecordService,
        private modalService: NgbModal,
        private cdref: ChangeDetectorRef,
        private load: LoadService,
        @Inject(APP_BASE_HREF) private baseHref: string,
    ) {
        if (this.load && this.load.configData.pages?.record?.filialMode) {
            this.isFilialMode = !!this.load.configData.pages.record.filialMode;
        }
    }
    protected loadingComplite: boolean = false;
    ngOnInit(): void {
        this.periodStart = new Date();
        this.periodEnd = moment(this.periodStart).add(30, 'days').toDate();
        this.btnFiltrTek();
        if (this.isFilialMode) {
            this.isFilialListVisible = true;
            this.changeTab(0);
        }
        this.loadingComplite = false;
        this.getStaticfilterBTN();
        this.getSpecList();
        this.getFilialList();
        this.selectedSpec = null;
        this.selectedFilial = null;
        this.selectedSrv = null;
        this.searchClick();
        //автоматическое переключение с десктопной версии на мобильную на всякий случай
        this.mediaQuery = window.matchMedia('(max-width: 500px)');
        this.mediaQueryListener = (e) => {
            this.isMobile = e.matches;
            if (this.isMobile) {
                // this.openMobileTemplate = true;
            } else {
                this.openMobileTemplate = false;
            }
        };
        this.mediaQuery.addListener(this.mediaQueryListener);
        this.isMobile = this.mediaQuery.matches;
        if (this.isMobile) {
            // this.openMobileTemplate = true;
        } else {
            this.openMobileTemplate = false;
        }
        //автоматическое переключение с десктопной версии на мобильную на всякий случай
    }
    ngAfterViewInit() {
        if (this.InputBlocSpecEL) {
            this.InputBlocSpecEL.nativeElement.focus();
        }
        setTimeout(() => {
            this.isSearchListVisible = true;
            this.searchAmine = 'on';

            this.cdref.detectChanges();
        }, 0);
        setTimeout(() => {
            this.loadingComplite = true;
        }, 100);
        this.toggleTabPosition();
    }

    ngOnDestroy() {
        if (this.mediaQueryListener) {
            this.mediaQuery?.removeListener(this.mediaQueryListener);
        }
    }
    experienceText(exp: string): string {
        return Utils.experienceText(exp);
    }
    changeTab(n: number) {
        this.searchAmine = '';

        if (n === 0) {
            this.staticFilterSelected = null;
            this.filialList = this._filialList;
            this.loadingListDoc = false;
            this.loadingListDepSpec = false;
        } else {
            // this.getSpecList();
            this.specList = this._specList;
        }
        this.statusTab = n;
        setTimeout(() => {
            this.isFilialListVisible = true;
            this.isSearchListVisible = true;
        }, 0);
        this.onTalonPickerClosed();
        this.paramsTalonpicker = {
            doctorId: 0,
            periodStart: new Date(),
            periodEnd: new Date(new Date().setDate(new Date().getDate() + 30)),
            depId: null,
        };
        this.openMobileTemplate = false;
        this.selectedSpec = null;
        this.selectedFilial = null;
        this.cdref.detectChanges();
        this.recDoctors = [];
        this.selectedSpec = null;
        this.searchStr = '';
        this.selectedSrvMap = {};

        this.toggleTabPosition();
    }

    toggleTabPosition() {
        const headerTabs = document.querySelector('.header__tabs');
        if (this.statusTab === 1) {
            headerTabs?.classList.add('tab-right');
        } else {
            headerTabs?.classList.remove('tab-right');
        }
    }
    setDoctorsExpAndSpec() {
        this.recDoctors?.forEach((item, index) => {
            if (this.recDoctors) {
                this.recDoctors[index].workExp =
                    item?.infoDoc?.find((value) =>
                        value.queston.toLowerCase().includes('стаж'),
                    )?.answer || '';
                this.recDoctors[index].workSpec =
                    item?.infoDoc?.find(
                        (value) =>
                            value.queston
                                .toLowerCase()
                                .includes('направление') ||
                            value.queston
                                .toLowerCase()
                                .includes('специальность') ||
                            value.queston
                                .toLowerCase()
                                .includes('специализация'),
                    )?.answer || '';
            }
        });
    }

    // Получить список специальностей
    getSpecList() {
        //    this.selectedSpec = null;

        // this.setSearchListVisible(false);
        this.loadingListSpec = true;
        this.specList = [];
        this._specList = [];
        let staticId: number | null = null;
        if (this.staticFilterSelected) {
            staticId = this.staticFilterSelected;
        }

        this.rs
            .getSpecList(this.periodStart, this.periodEnd, staticId)
            .subscribe(
                (val) => {
                    //

                    this.specList = val.sort((a, b) => {
                        const aText = a.text.toUpperCase(),
                            bText = b.text.toUpperCase();
                        if (aText < bText) {
                            return -1;
                        }
                        if (aText > bText) {
                            return 1;
                        }
                        return 0;
                    });
                    this.specList = val;
                    // this.specList = [
                    //     ...this.specList,
                    //     ...this.specList,
                    //     ...this.specList,
                    //     ...this.specList,
                    //     ...this.specList,
                    //     ...this.specList,
                    // ];
                    this._specList = this.specList;

                    this.loadingListSpec = false;
                    this.cdref.detectChanges();
                },
                (error) => {
                    console.error(error);
                    this.loadingListSpec = false;
                    this.cdref.detectChanges();
                },
            );

        this.setSearchListVisible(true);
        this.searchAmine = 'on';
    }
    getFilialList() {
        this.loadingListFil = true;
        this.isFilialListVisible = true;
        this.rs.getFilialList().subscribe(
            (val) => {
                this.filialList = val.sort((a, b) => {
                    const aText = a.dep_name.toUpperCase(),
                        bText = b.dep_name.toUpperCase();
                    if (aText < bText) {
                        return -1;
                    }
                    if (aText > bText) {
                        return 1;
                    }
                    return 0;
                });
                this._filialList = this.filialList;

                // this.filialList = [
                //     ...this.filialList,
                //     ...this.filialList,
                //     ...this.filialList,
                //     ...this.filialList,
                //     ...this.filialList,
                // ];
                setTimeout(() => {
                    this.loadingListFil = false;
                }, 500);

                this.cdref.detectChanges();
            },
            (error) => {
                console.error(error);
                this.loadingListFil = false;
                this.cdref.detectChanges();
            },
        );
    }
    getSpecByFilialList(depId: number) {
        this.loadingListDepSpec = true;
        this.specByFilialList = [];

        this.rs
            .getSpecByFilialList(
                this.periodStart,
                this.periodEnd,
                null, // staticId
                depId,
            )
            .subscribe(
                (val) => {
                    this.specByFilialList = val
                        .sort((a, b) => {
                            const aText = a.text.toUpperCase(),
                                bText = b.text.toUpperCase();
                            return aText.localeCompare(bText);
                        })
                        .map((item) => ({ ...item, depid: depId }));

                    this._specByFilialList = [...this.specByFilialList];

                    // this.specByFilialList = [
                    //     ...this.specByFilialList,
                    //     ...this.specByFilialList,
                    //     ...this.specByFilialList,
                    //     ...this.specByFilialList,
                    // ];

                    // Отключаем лоадер только после обработки данных
                    setTimeout(() => {
                        this.loadingListDepSpec = false;
                    }, 100);
                    this.cdref.detectChanges();
                },
                (error) => {
                    console.error(error);
                    this.loadingListDepSpec = false; // Важно отключить лоадер даже при ошибке
                    this.cdref.detectChanges();
                },
            );
    }
    initializeOriginalServiceLists(): void {
        if (this.recDoctors) {
            this.recDoctors.forEach((doctor) => {
                if (doctor.srvlist && doctor.srvlist.length > 0) {
                    this.originalSrvLists[doctor.doctorid] = [
                        ...doctor.srvlist,
                    ];
                }
            });
        }
    }
    // Получить список специальностей
    getDocList(p_SpecID: number, p_depID: number | null) {
        //    this.selectedSpec = p_SpecID;

        this.recDoctors = [];
        this.loadingListDoc = true;
        this.originalSrvLists = {};

        let staticId: number | null = null;
        if (this.staticFilterSelected && this.staticFilterSelected.keyid) {
            staticId = this.staticFilterSelected.keyid;
        }
        this.rs
            .getDocList(
                p_SpecID,
                this.periodStart,
                this.periodEnd,
                staticId,
                p_depID,
            )
            .subscribe(
                (val) => {
                    this.recDoctors = val;
                    this.recDoctors.forEach((item) => {
                        item.rdatemin = strToDate(item.dat_bgn);
                        item.rdatemax = strToDate(item.dat_end);
                        if (item.srvlist && item.srvlist.length > 0) {
                            this.originalSrvLists[item.doctorid] = [
                                ...item.srvlist,
                            ];
                        }
                    });

                    // this.recDoctors = [
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    //     ...this.recDoctors,
                    // ];
                    const docInfoPromises = this.recDoctors.map((doc) =>
                        lastValueFrom(this.ds.getDocAboutInfo(doc.doctorid)),
                    );
                    Promise.allSettled(docInfoPromises)
                        .then((res) => {
                            res.forEach((info, i) => {
                                if (
                                    this.recDoctors !== null &&
                                    info.status === 'fulfilled'
                                ) {
                                    this.recDoctors[i].infoDoc = info.value;
                                }
                            });
                        })
                        .catch(console.log)
                        .finally(() => {
                            this.setDoctorsExpAndSpec();
                            this.loadingListDoc = false;
                        });
                    this.initializeOriginalServiceLists();
                },

                (error) => {
                    console.error(error);
                    this.loadingListDoc = false;
                },
            );
    }

    selectSpec(srvID: number, depId: number | null) {
        // srvID - некорректное название переменной, передается keyid специальности =>
        this.isSearchListVisible = false;
        this.isFilialListVisible = false;
        this.isDropdownOpen = false;
        // this.specIsSelected = true

        this.selectedSpec = this.specList.filter(
            (item) => item.keyid == srvID,
        )[0];

        this.searchAmine = 'off';

        this.searchStr = this.selectedSpec?.text;
        this.getDocList(srvID, depId);
        this.setSearchListVisible(false);

        this.paramsTalonpicker = {
            doctorId: 0,
            srvId: srvID, // идентичен со specId \/ (см ниже)
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            specId: this.selectedSpec.keyid, // (здесь) идентичен с srvId, передается одно и то же
            srv: this.selectedSrv ? this.selectedSrv : undefined,
            Idep: this.selectedFilial ? this.selectedFilial : undefined,
            depId: this.selectedFilial?.dep_id
                ? this.selectedFilial.dep_id
                : null,
        };

        if (window.innerWidth < 500) {
            this.openMobileTemplate = true;
            setTimeout(() => {
                this.cdref.detectChanges();
            }, 0);
        } else {
            this.openMobileTemplate = false;
        }
        this.talonPickerAnime = 'on';

        this.isSearchListVisible = false;
    }

    selectFil(depId: number) {
        // this.isSearchListVisible = false;
        this.selectedFilial = this.filialList.filter(
            (item) => item.dep_id == depId,
        )[0];
        this.searchStr = '';
        this.searchAmine = 'off';
        // this.searchStr = this.selectedFilial.dep_name;
        this.getSpecByFilialList(depId);

        if (window.innerWidth < 500) {
            this.openMobileTemplate = false;
        } else {
            this.openMobileTemplate = false;
        }

        this.talonPickerAnime = 'on';
        this.isSearchListVisible = true;
    }

    onSearchChange(searchValue: string): void {}
    changeSearch(str: string) {
        if (this.statusTab === 1) {
            if (str.length > 0) {
                this.specList = this._specList.filter(
                    (item) =>
                        item.text.toUpperCase().indexOf(str.toUpperCase()) !==
                        -1,
                );
            } else {
                this.specList = this._specList;
            }
        } else {
            if (!this.selectedFilial) {
                this.filialList = this._filialList.filter(
                    (item) =>
                        item.dep_name
                            .toUpperCase()
                            .indexOf(str.toUpperCase()) !== -1,
                );
            }

            if (str.length > 0) {
                this.specByFilialList = this._specByFilialList.filter(
                    (item) =>
                        item.text.toUpperCase().indexOf(str.toUpperCase()) !==
                        -1,
                );
            } else {
                this.specByFilialList = this._specByFilialList;
            }
        }
    }

    changeSearchSrv(searchText: string, doctorId: number): void {
        // ищем доктор в общем списке
        const doctor = this.recDoctors?.find(
            (doc) => doc.doctorid === doctorId,
        );

        if (!doctor) return;

        if (!this.originalSrvLists[doctorId] && doctor.srvlist) {
            this.originalSrvLists[doctorId] = [...doctor.srvlist];
        }

        // если строка пустая
        if (!searchText || searchText.trim() === '') {
            if (this.originalSrvLists[doctorId]) {
                doctor.srvlist = [...this.originalSrvLists[doctorId]];
            }
            return;
        }

        // Filter services based on search text
        if (this.originalSrvLists[doctorId]) {
            const searchLower = searchText.toLowerCase();
            doctor.srvlist = this.originalSrvLists[doctorId].filter(
                (service) =>
                    service.text.toLowerCase().includes(searchLower) ||
                    (service.description &&
                        service.description
                            .toLowerCase()
                            .includes(searchLower)),
            );
        }
    }

    searchClick() {
        this.panelRnumbAmine = 'off';
        if (this.searchAmine === 'off') {
            this.searchAmine = 'on';
        } else {
            this.searchAmine = 'off';
        }

        // Если специальность не меняется
        if (this.searchAmine === 'off' && this.selectDoc) {
            if (this.selectDoc.srvlist && this.selectDoc.srvlist.length > 0) {
                if (this.selectedSrv) {
                    this.panelRnumbAmine = 'on';
                    this.showCalendar = true;
                }
            } else {
                this.panelRnumbAmine = 'on';
            }
        }
    }

    changePeriod(dt: IPeriod) {
        //
        this.dtBegin = dt.begin;
        this.dtEnd = dt.end;
        //    this.getServicesSize();
    }

    // За сегодня
    btnFiltrTek() {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
    }

    // За 3 дня
    btnFiltr3Day() {
        this.dtBegin = new Date();
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
    }

    getPeriodStr(dt1?: Date, dt2?: Date): string {
        let tmp = '';
        if (dt1 && dt2 && dt1.getMonth() == dt2.getMonth()) {
            // Одинаковый месяц
            tmp =
                '(' +
                moment(dt1).format('D') +
                ' - ' +
                moment(dt2).format('D MMM') +
                ')';
        } else {
            tmp =
                '(' +
                moment(dt1).format('D MMM') +
                ' - ' +
                moment(dt2).format('D MMM') +
                ')';
        }
        return tmp;
    }
    getImgSrcFilials(): string {
        return `${this.configS.getValue('hostBackend')}/img/filials/not.png`;
    }
    getImgSrcSpec(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/spec/not.png`;
    }

    getImgSrcDoc(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    getImgSrcErr() {
        return `${this.configS.getValue('hostBackend')}/img/doc/not.png`;
    }

    getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        elem.src = `${this.configS.getValue('hostBackend')}/img/doc/not.png`;
    }

    /**
     * В случае если изображение на сервере не найдено то грузим локальное изображение
     * @param event
     */
    // public errorHandlerIMG(event: any, type: string): void {
    //     event.target.src = `${this.configS.getValue(
    //         'hostBackend'
    //     )}/img/${type}/not.png`;
    // }

    public errorHandlerIMG(event: any, type: string): void {
        const elem = event.target as HTMLImageElement;

        if (elem.dataset.defaultImageSet === 'true') {
            return;
        }
        let localFallback = '';
        switch (type) {
            case 'filial':
                localFallback = `${this.baseHref}assets/img/filials/not.png`;
                elem.src = localFallback;
                break;

            case 'spec':
                localFallback = `${this.baseHref}assets/img/spec/not.png`;
                elem.src = localFallback;
                break;
        }

        elem.dataset.defaultImageSet = 'true';
    }

    /* Выбор доктора */
    selectedDoc(doc: IDoctor) {
        this.selectDoc = doc;
        this.selectedSrv = null;
        // this.RnumbDateSetParams();
    }

    /* передача параметров в номерки */
    RnumbDateSetParams() {
        this.paramsTalonpicker = {
            doctorId: this.selectedDoctor?.doctorid!,
            specId: this.selectedSpec?.keyid,
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            srv: this.selectedSrv!,
            staticFilterSelected: this.staticFilterSelected!,
            infoDoc: this.selectedDoctor
                ? this.selectedDoctor.infoDoc
                : this.selectDoc?.infoDoc,
            Idep: this.selectedFilial ? this.selectedFilial : undefined,
            depId: this.selectedFilial?.dep_id
                ? this.selectedFilial.dep_id
                : null,
            selectedDoctor: this.selectedDoctor,
            selectedSpec:
                this.selectedSpec !== null ? this.selectedSpec : undefined,
        };

        if (
            this.selectDoc &&
            this.selectDoc.srvlist &&
            this.selectDoc.srvlist.length > 0
        ) {
            // c услугами , this.selectedSrv определяеться при выборе услуги из выпадающего списка список модалка
            if (this.selectedSrv) {
                this.panelRnumbAmine = 'on'; // Включить анимацию

                let param: IRnumbDate = {
                    doctorId: 0,
                    specId: 0,
                    periodStart: new Date(),
                    periodEnd: new Date(),
                    srv: this.selectedSrv,
                    depId: null,
                };
                param.doctorId = this.selectDoc.doctorid;
                if (this.selectedSpec) {
                    param.specId = this.selectedSpec.keyid;
                }
                param.periodStart = this.periodStart;
                param.periodEnd = this.periodEnd;
                if (this.staticFilterSelected) {
                    param.staticFilterSelected = this.staticFilterSelected;
                }
                this.rs.RnumbDateSetParams(param);

                this.showCalendar = true;
            } else {
                this.panelRnumbAmine = 'off';
            }
        } else {
            // Без услуг
            this.panelRnumbAmine = 'on'; // Включить анимацию
            let param: IRnumbDate = {
                doctorId: 0,
                specId: 0,
                periodStart: new Date(),
                periodEnd: new Date(),
                depId: null,
            };
            // @ts-ignore
            param.doctorId = this.selectDoc?.doctorid;
            if (this.selectedSpec) {
                param.specId = this.selectedSpec.keyid;
            }
            param.periodStart = this.periodStart;
            param.periodEnd = this.periodEnd;
            if (this.staticFilterSelected) {
                param.staticFilterSelected = this.staticFilterSelected;
            }

            this.rs.RnumbDateSetParams(param);
        }
        if (window.innerWidth < 500) {
            this.openMobileTemplate = true;
            this.showCalendar = false;
        } else {
            this.showCalendar = true;
        }
    }
    /* Список кнопок */
    getStaticfilterBTN() {
        this.staticFilterBTNs = [];
        this.staticFilterSelected = null;
        this.rs.getStacfilterList().subscribe(
            (val) => {
                this.staticFilterBTNs = val;
            },
            (error) => {
                console.error(error);
            },
        );
    }

    /* фильтр */

    btnStaticFiltr(btnST: IStaticFilter) {
        if (this.staticFilterSelected !== btnST.keyid) {
            this.staticFilterSelected = btnST.keyid;
        } else {
            this.staticFilterSelected = null;
        }

        this.getSpecList();
        this.cdref.detectChanges();
        this.recDoctors = [];
        this.searchStr = '';
        this.searchAmine = 'on';
        this.setSearchListVisible(true);
    }
    setSearchListVisible(value: boolean) {
        this.isSearchListVisible = value;
    }

    onClosePanelTalon(event: number) {
        this.selectDoc = null;
        this.panelRnumbAmine = 'off';
    }

    isShowSrvList(doc: IDoctor): boolean {
        if (doc && doc.srvlist && doc.srvlist.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    invalidSrv(doctorid: number): boolean {
        let f: boolean = false;
        if (
            this.selectDoc &&
            this.selectDoc.doctorid == doctorid &&
            !this.selectedSrv
        ) {
            f = true;
        }
        return f;
    }
    openDocInfoModal(doc: IDoctor, event: Event) {
        event.stopPropagation();
        const modal = this.modalService.open(DocInfoModalComponent);
        modal.componentInstance.doc = doc;
        modal.componentInstance.spec = this.selectedSpec?.text;
    }

    openServDescModal(docSrv: IServ, event: Event) {
        event.stopPropagation();
        // const modal = this.modalService.open(ServDescModalComponent);
        // modal.componentInstance.docSrv = docSrv;
        // modal.componentInstance.spec = this.selectedSpec?.text;
        const modal = this.modalService.open(ServModalComponent);
        modal.componentInstance.serv = docSrv;
    }

    onTalonPickerClosed() {
        // this.showTalonPicker = false;
        this.showMobilePicker = false;
        this.showCalendar = false;
    }
    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    onFilterChanged(event: any) {
        switch (event.typeEvent) {
            case 'clearFilter':
                this.staticFilterSelected = null;
                this.getSpecList();
                this.toggleDropdown();
                this.recList = [];
                this.searchStr = '';
                this.searchAmine = 'on';

                break;
            case 'getStacFilters':
                this.staticFilterBTNs = event.data;
                break;

            case 'filterListUpdated':
                this.cdref.detectChanges();
                this.staticFilterSelected = event.data;
                this.getSpecList();
                this.recDoctors = [];
                this.searchStr = '';
                this.toggleDropdown();
                break;
        }
    }

    rcountText(count: number): string {
        if (!count) return 'Нет номерков';

        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return `Осталось ${count} номерков`;
        }

        switch (lastDigit) {
            case 1:
                return `Остался ${count} номерок`;
            case 2:
            case 3:
            case 4:
                return `Осталось ${count} номерка`;
            default:
                return `Осталось ${count} номерков`;
        }
    }

    formatDoctorName(fullName: string): string {
        const nameParts = fullName.split(' ');
        if (nameParts.length >= 2) {
            const lastName = nameParts[0];
            const initials = nameParts
                .slice(1)
                .map((part) => part.charAt(0) + '.')
                .join('');
            return `${lastName} ${initials}`;
        }
        return fullName;
    }
    getFioDoc(doctor: IDoctor): string {
        if (!doctor || !doctor.l_name || !doctor.f_name) return '';
        return `${doctor.l_name} ${doctor.f_name} ${doctor.s_name || ''}`;
    }
    openSelectStates: { [key: number]: boolean } = {};

    toggleSelect(doctorId: number) {
        if (this.openSelectStates.hasOwnProperty(doctorId)) {
            if (this.openSelectStates[doctorId]) {
                // закрываем выпадающий список если он уже открыт
                this.openSelectStates[doctorId] = false;
            } else {
                Object.keys(this.openSelectStates).forEach((key) => {
                    this.openSelectStates[Number(key)] = false;
                });
                this.openSelectStates[doctorId] = true;
            }
        } else {
            this.openSelectStates[doctorId] = true;
        }
    }
    selectedSrvMap: { [key: number]: IServ } = {};
    loadingCalendar = false;
    showMobileServiceList: boolean = false;

    openSrvList(event: { service: IServ; doctor: IDoctor }) {
        this.selectedSrv = event.service;
        this.selectedDoctor = event.doctor;
        this.showMobileServiceList = true;
    }
    pickedDoctor: IDoctor | null = null;
    pickDoc(event: { doctor: IDoctor }) {
        this.selectedDoctor = event.doctor;

        // Update paramsTalonpicker to include the doctor ID
        if (this.selectedDoctor) {
            this.paramsTalonpicker = {
                ...this.paramsTalonpicker,
                doctorId: this.selectedDoctor.doctorid,
                specId: this.selectedSpec?.keyid,
                periodStart: this.periodStart,
                periodEnd: this.periodEnd,
                selectedDoctor: this.selectedDoctor,
                Idep: this.selectedFilial ? this.selectedFilial : undefined,
                depId: this.selectedFilial?.dep_id
                    ? this.selectedFilial.dep_id
                    : null,
            };
        }

        // For mobile, show service list
        this.showMobileServiceList = true;
    }
    checkSrv: boolean = false;
    selectService(event: { service: IServ; doctor: IDoctor }) {
        const { service, doctor } = event;

        // this.pickDoc(event);

        this.selectedDoctor = doctor;
        this.activeItem = doctor;
        this.searchStrSrv = { ...service };
        this.loadingCalendar = true;

        if (doctor) {
            this.selectedSrv = service;
            this.selectedSrvMap[doctor.doctorid] = service;
            this.openSelectStates[doctor.doctorid] = false;

            // Make sure service.keyid exists before using it
            const srvId = service && service.keyid ? service.keyid : undefined;

            if (this.selectedSrv) {
                this.paramsTalonpicker = {
                    doctorId: this.selectedDoctor.doctorid,
                    srvId: srvId,
                    periodStart: this.periodStart,
                    periodEnd: this.periodEnd,
                    specId: this.selectedSpec?.keyid,
                    srv: service,
                    infoDoc: this.selectedDoctor.infoDoc,
                    selectedDoctor: this.selectedDoctor,
                    selectedSpec: this.selectedSpec
                        ? this.selectedSpec
                        : undefined,
                    Idep: this.selectedFilial ? this.selectedFilial : undefined,
                    depId: this.selectedFilial?.dep_id
                        ? this.selectedFilial.dep_id
                        : null,
                };
            }

            if (this.isMobile) {
                this.showMobileServiceList = true;
            } else {
                this.showCalendar = true;
            }

            this.RnumbDateSetParams();
            setTimeout(() => {
                this.loadingCalendar = false;
            }, 1000);
        }
        this.cdref.detectChanges();
    }

    // Добавим методы для обработки событий от компонента карточки
    handleToggleSelect(doctorId: number) {
        this.toggleSelect(doctorId);
        this.showCalendar = false;
    }

    handleSearchSrvChanged(event: { searchText: string; doctorId: number }) {
        this.changeSearchSrv(event.searchText, event.doctorId);
    }

    handleOpenDocInfo(event: { doctor: IDoctor; event: Event }) {
        this.openDocInfoModal(event.doctor, event.event);
    }

    handleOpenServDesc(event: { service: IServ; event: Event }) {
        this.openServDescModal(event.service, event.event);
    }

    clearSearch(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.selectedSpec = null;
        this.searchStr = '';
        this.searchAmine = 'on';
        // this.getSpecList();
        this.changeSearch(this.searchStr);
        this.openMobileTemplate = false;
        setTimeout(() => {
            this.isSearchListVisible = true;
        }, 100);
        // this.isSearchListVisible = true;
        this.loadingListDoc = false;
    }

    toggleSearchList(event: Event) {
        event.stopPropagation();
        this.showCalendar = false;
        this.searchAmine = 'on';
        if (this.statusTab === 0) {
            // this.isFilialListVisible = !this.isFilialListVisible;
        }

        if (window.innerWidth < 500 && this.openMobileTemplate) {
            this.isSearchListVisible = !this.isSearchListVisible;
            this.loadingListDoc = false;
        } else {
            this.searchAmine = 'on';
            if (this.searchStr.length > 0 && this.recDoctors) {
                this.changeSearch(this.searchStr);

                this.isSearchListVisible = !this.isSearchListVisible;
                // this.isFilialListVisible = !this.isFilialListVisible;
            } else {
                this.isSearchListVisible = true;
            }
        }
        Object.keys(this.openSelectStates).forEach((key) => {
            this.openSelectStates[Number(key)] = false;
        });
    }

    mobileFilterHandler() {
        this.isMobileFlilterOpen = !this.isMobileFlilterOpen;
    }
    closeRegistrationPicker() {
        // this.selectedDoctor = undefined;

        this.openMobileTemplate = false;
    }

    // Добавьте эту функцию в класс RecComponent
    // Обновленная функция getHeaderLabel в классе RecComponent
    getHeaderLabel(): string {
        if (this.selectedFilial && this.selectedSpec) {
            // Если выбраны и филиал, и специальность, показываем оба с разделителем
            return `${this.selectedFilial.dep_name} > ${this.selectedSpec.text}`;
        } else if (this.selectedSpec) {
            // Если выбрана только специальность
            return this.selectedSpec.text;
        } else if (this.selectedFilial) {
            // Если выбран только филиал
            return this.selectedFilial.dep_name;
        } else {
            // Если ничего не выбрано
            return 'Филиалы';
        }
    }

    goBackToFilial() {
        // if (!this.selectedFilial) {
        //     return;
        // }

        // const filialId = this.selectedFilial.dep_id;
        // const filialName = this.selectedFilial.dep_name;

        this.selectedFilial = null;
        this.selectedSpec = null;
        this.selectedSrv = null;
        this.selectedSrvMap = {};
        this.recDoctors = [];
        this.showCalendar = false;
        this.openMobileTemplate = false;
        this.searchStr = '';
        this.changeSearch(this.searchStr);
        // this.getSpecByFilialList(filialId);

        this.isSearchListVisible = true;
        this.isFilialListVisible = true;
        this.cdref.detectChanges();
    }

    /**
     * функция для возврата
     */
    clearSelection() {
        if (this.statusTab === 0) {
            if (this.selectedSpec) {
                this.selectedSpec = null;
                this.recDoctors = [];
                this.showCalendar = false;
                this.openMobileTemplate = false;
                this.selectedSrvMap = {};
                this.searchStr = '';
                this.searchAmine = 'on';
                this.changeSearch(this.searchStr);
                setTimeout(() => {
                    this.isSearchListVisible = true;
                }, 100);
            } else if (this.selectedFilial) {
                this.selectedFilial = null;
                this.searchStr = '';
                this.specByFilialList = [];
                // this.getFilialList();
                this.isSearchListVisible = true;
            }
        } else {
            // if (this.selectedSpec) {
            this.selectedSpec = null;
            this.recDoctors = [];
            this.searchStr = '';
            this.showCalendar = false;
            this.openMobileTemplate = false;
            this.getSpecList();
            this.isSearchListVisible = true;
            this.searchAmine = 'on';
            // }
        }
        this.cdref.detectChanges();
    }

    backToSrv() {}
    isCalendarActive: boolean = false;
    showCalendarIcon: boolean = false;
    calendarHandler(): void {
        this.isCalendarActive = !this.isCalendarActive;
    }

    getFullName(doctor?: IDoctor | null): string {
        if (!doctor) return '';
        return `${doctor.l_name || ''} ${doctor.f_name || ''} ${
            doctor.s_name || ''
        }`.trim();
    }
    showDropdown: boolean = false;
    selectedDep: IDep | null = null;
    depList: Department[] = [];
    talonListAll: IRecTalon[] = [];
    depPicked: boolean = false;
    talonListFiltered: IRecTalon[] = [];
    headerTxt = ''; // Заголовок
    selectedDay: moment.Moment | null = moment();
    activeDays: moment.Moment[] = []; // NOT sorted by date

    placeholderDep(): string {
        return this.selectedDep ? this.selectedDep.text : 'Выберите филиал';
    }

    private async getDepList(params: IRnumbDate) {
        this.depList = await lastValueFrom(this.rs.getDepListv2(params));
        this.depList = this.depList.filter((dep) => {
            const deps = new Set();
            this.talonListAll.forEach((talon) => deps.add(talon.depid));
            return deps.has(dep.keyid);
        });
    }

    selectDep(dep: Department | null) {
        this.showCalendarIcon = true;
        this.headerTxt = `${moment(this.selectedDay).format('DD MMMM YYYY')}`;
        if (dep?.keyid === -1) {
            this.selectedDep = null;

            this.depPicked = true;
            this.showDropdown = false;
            this.talonListFiltered = this.filterTalons();
        } else {
            this.selectedDep = dep;
            this.showDropdown = false;
            this.talonListFiltered = this.filterTalons();
            // this.talonListFiltered = [
            //     ...this.talonListFiltered,
            //     ...this.talonListFiltered,
            //     ...this.talonListFiltered,
            //     ...this.talonListFiltered,
            //     ...this.talonListFiltered,
            //     ...this.talonListFiltered,
            // ];
        }
        this.activeDays = this.filterActiveDays();
    }

    filterTalons() {
        return this.talonListAll.filter((talon) => {
            return (
                talon.dtBegin?.getFullYear() === this.selectedDay?.year() &&
                talon.dtBegin?.getMonth() === this.selectedDay?.month() &&
                talon.dtBegin?.getDate() === this.selectedDay?.date() &&
                (this.selectedDep
                    ? talon.depid === this.selectedDep.keyid
                    : true)
            );
        });
    }

    private filterActiveDays() {
        if (!this.selectedDep) {
            this.activeDays = this.talonListAll
                .map((talon) => moment(strToDate(talon.dat_begin_str)))
                .filter((day, index, self) => self.indexOf(day) === index);
        } else {
            this.activeDays = this.talonListAll
                .filter((talon) => talon.depid === this.selectedDep?.keyid)
                .map((talon) => moment(strToDate(talon.dat_begin_str)))
                .filter((day, index, self) => self.indexOf(day) === index);
        }
        return this.activeDays;
    }

    closeMobileServiceList(): void {
        this.showMobileServiceList = false;
    }

    srvChanged(event: { typeEvent: string; data: any }): void {
        // this.selectedSpec?.keyid = event.data.srvId;

        if (event.data && event.data.keyid) {
            this.selectedSrv = event.data;

            if (this.selectedSpec) {
                this.paramsTalonpicker.specId = this.selectedSpec.keyid;
            }

            if (this.selectedDoctor) {
                this.paramsTalonpicker.doctorId = this.selectedDoctor.doctorid;
            }
        }

        this.RnumbDateSetParams();
        this.showMobileServiceList = false;
        this.showMobilePicker = true;
    }
}
